'use strict';
import $ from 'jquery';

export default class M136 {
  static init() {
    $('.module-m136').each((index, el) => {
      new M136($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.find('.dropdown-filter').on('selected', (e, li) => {
      let pane = $(li).data('target');
      $el.find('.tab-pane').removeClass('show active');
      $(pane).tab('show');
      $el.find('.nav-link').removeClass('active');
      $el.find('.nav-link[href="' + pane + '"]').addClass('active');
    });
    this.el.find('.nav-link').on('shown.bs.tab', (e) => {
      $el.find('select').val($(e.currentTarget).attr('href'));
    });
  }
}
